export default __webpack_public_path__ + "static/media/DAIF_Data_Screen3_In.a78b0cf3.mp4";